import {
  MailTemplateModel,
  MailTemplateGetAttributes,
  MailTemplateCreateAttributes,
  MailTemplateUpdateAttributes,
  MailTemplateCollection,
} from 'src/models/MailTemplateModel';
import { Notify } from 'quasar';
import {
  MailTemplateAdapterInteface,
  ListMailTemplatesInput as BaseListMailTemplatesInput,
} from 'src/adapter/MailTemplateAdapterInterface';
import { apiErrorHandler } from 'src/error/handler/apiErrorHandler';
export type ListMailTemplatesInput = BaseListMailTemplatesInput;
export class MailTemplateApiClass {
  adapter: MailTemplateAdapterInteface;
  constructor(adapter: MailTemplateAdapterInteface) {
    this.adapter = adapter;
  }
  async listMailTemplates(
    conditions?: ListMailTemplatesInput
  ): Promise<{ total: number; data: MailTemplateCollection }> {
    try {
      const res = await this.adapter.listMailTemplates(conditions);
      return {
        total: res.total,
        data: res.data.map(
          (mailTemplate: MailTemplateGetAttributes) =>
            new MailTemplateModel(mailTemplate)
        ),
      };
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async getMailTemplate(id: string): Promise<MailTemplateModel> {
    try {
      const mailTemplate = await this.adapter.getMailTemplate(id);
      return new MailTemplateModel(mailTemplate);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async createMailTemplate(
    attributes: MailTemplateCreateAttributes
  ): Promise<MailTemplateModel> {
    try {
      const mailTemplate = await this.adapter.createMailTemplate(attributes);
      Notify.create({
        type: 'positive',
        message: '作成しました',
      });
      return new MailTemplateModel(mailTemplate);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async updateMailTemplate(
    id: string,
    attributes: MailTemplateUpdateAttributes
  ): Promise<MailTemplateModel> {
    try {
      const mailTemplate = await this.adapter.updateMailTemplate(
        id,
        attributes
      );
      Notify.create({
        type: 'positive',
        message: '更新しました',
      });
      return new MailTemplateModel(mailTemplate);
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
  async deleteMailTemplate(id: string): Promise<boolean> {
    try {
      const res = await this.adapter.deleteMailTemplate(id);
      Notify.create({
        type: 'positive',
        message: '削除しました',
      });
      return res;
    } catch (e) {
      throw apiErrorHandler(e);
    }
  }
}
